import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const TargetedShiftInfoText = styled(Typography)(({ theme }) => ({
  fontSize: "14px",
  color: theme.palette.text.secondary,
  textAlign: "justify",
  whiteSpace: "pre-line",
}));
